enum ContactStatus {
    Active = 90,
    Inactive = 91
}

export default ContactStatus;